import { BonusesActions, BonusesActionType } from '@/store/bonuses/actions';
import { BffBonusData, BffBonusType } from '@lucky7ventures/bff-types';

export interface BonusesState {
  [BffBonusType.Active]: BffBonusData[];
  [BffBonusType.Available]: BffBonusData[];
  loading: boolean;
  error: boolean;
}

const initialState: BonusesState = {
  [BffBonusType.Active]: [],
  [BffBonusType.Available]: [],
  loading: false,
  error: false,
};

export const bonusesReducer = (state = initialState, action: BonusesActions): BonusesState => {
  switch (action.type) {
    case BonusesActionType.GetBonuses:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case BonusesActionType.GetBonusesError:
      return {
        ...state,
        [BffBonusType.Active]: [],
        [BffBonusType.Available]: [],
        loading: false,
        error: true,
      };
    case BonusesActionType.GetBonusesSuccess: {
      return {
        ...state,
        [BffBonusType.Active]: action.bonuses[BffBonusType.Active],
        [BffBonusType.Available]: action.bonuses[BffBonusType.Available],
        loading: false,
        error: false,
      };
    }
    case BonusesActionType.ResetBonusesState: {
      return {
        ...state,
        [BffBonusType.Active]: [],
        [BffBonusType.Available]: [],
        loading: false,
        error: false,
      };
    }

    default:
      return state;
  }
};
